module.exports = __webpack_public_path__ + "static/media/bshares.3cc910aa.png";